import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function HtmlPublicCollateral() {
  const { slug } = useParams();
  const [htmlCode, setHtmlCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError(null);

    async function fetchData() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL ;
        console.log("apiUrl", apiUrl);  
        const response = await fetch(`${apiUrl}api/tailspin/html/${slug}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch HTML collateral: ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.message || 'Failed to fetch HTML collateral');
        }
        
        // Extract HTML code from the response structure
        const collateralHtml = result.data?.collateral;
        
        setHtmlCode(collateralHtml);
        
        console.log("HTML Code loaded:", collateralHtml);
      } catch (err) {
        console.error('Error fetching HTML collateral:', err);
        setError(err.message || "Failed to fetch HTML collateral.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-700 text-lg font-medium">Loading HTML collateral...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-red-100">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Error Loading Collateral</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!htmlCode) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
          <div className="text-gray-400 text-5xl mb-4">📄</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">No Collateral Found</h2>
          <p className="text-gray-600">The requested HTML collateral could not be found.</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen w-full"
      dangerouslySetInnerHTML={{ __html: htmlCode }}
    />
  );
}

